import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { InteractService, CommonUtilty, ComponentOutputDO, ArrayManipulations, ClientService, AppMetadataHandler } from 'app';
import { PolicyService } from '../../../FunctionalModules/PolicyIssuance/policy.service';
import { from } from 'rxjs';
import { take, takeWhile } from 'rxjs/operators';
import { ClaimPolicyDO } from 'app/BaseFramework/shared/models/other/policyDO';
interface policyIOPotentialDataPoints {
  proposalNum,
  baseProductFamilyCd,
  baseProductCd,
  baseProductTypeCd,
  sumInsuredAmt,
  statusCd,
  policyCommencementDt,
  policyExpiryDt,
  baseAgentId,
}

interface proposalIODataPoints {
  proposalNum,
  baseProductCd,
  statusCd,
}
@Component({
  selector: 'app-captured-policy-list',
  templateUrl: './captured-policy-list.component.html',
  styleUrls: ['./captured-policy-list.component.scss']
})
export class CapturedPolicyListComponent implements OnInit {
  _currentComponentName = 'CapturedPolicyListComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    private interactService: InteractService,
    private commonUtilty: CommonUtilty,
    private clientService: ClientService,
    private arrayManipulations: ArrayManipulations,
    private policyService: PolicyService,
    public appMetadataHandler: AppMetadataHandler) { }

  ngOnInit() {
    this.subscribeToParentEvent()
    this.subscribeToGetSelectedPolicies()

    if (this.enableAddPolicy == null || this.enableAddPolicy == undefined
      || this.enableRemovePolicy == null || this.enableRemovePolicy == undefined) {
        this.enableAddPolicy = true
        this.enableRemovePolicy = true
        throw "Framework Warning: It's mandatory to add 'enableAddPolicy' and 'enableRemovePolicy' flags on 'app-captured-policy-list'. This Warning will stop coming soon, and will converted to error. "
    }
  }


  @Output() componentOutput = new EventEmitter<any>();
  @Output() openModal = new EventEmitter<any>();
  @Output() updatePolicyList = new EventEmitter<any>();


  private _selectedPolicyList: Array<any> = [];

  @Input() set policyList(value: any) {
    if (value != null) {
      this._selectedPolicyList = value;
      this.emitPolicyList(this._selectedPolicyList);
    }
    else
      this._selectedPolicyList = []
  }
  get policyList() {
    return this._selectedPolicyList || [];
  }


  @Input() set inputDataForEdit(value: any) {
    if (value != null) {
      this._selectedPolicyList = value;
      this.emitPolicyList(this._selectedPolicyList);
    }
    else this._selectedPolicyList = [];
  }

  @Input() displayRoleCd: any
  @Input() enableRemovePolicy: any
  @Input() enableAddPolicy: any

  getPolicyList$
  proposalIOList = []
  proposalDOMap = {}
  fetchingProposalIOs = null
  policyListPreviousData = []
  emitPolicyList(data) {
    if (this.policyListPreviousData && Array.isArray(this.policyListPreviousData) &&
      data && Array.isArray(data) &&
      this.policyListPreviousData.length != data.length) {
      this.fetchingProposalIOs = true
    }
    else
      this.fetchingProposalIOs = false
    if (this.getPolicyList$) this.getPolicyList$.unsubscribe()
    this.getPolicyList$ = this.policyService.getProposalIOByPolicyNumList(data).subscribe(proposalIOListResp => {
      this.refreshProposalIOList(proposalIOListResp)
      this.proposalDOMap = this.extractProposalDOsMAPOutOfListOfProposalIOs(proposalIOListResp)
      this.fetchingProposalIOs = false
    })
    this.interactService.sendPolicyListToInsured(data);
  }

  proposalIODataPointsList = this.commonUtilty.deepCopy({})
  refreshProposalIOList(proposalIOListResp) {
    this.proposalIOList = this.commonUtilty.deepCopy(proposalIOListResp)
    if (this.commonUtilty.isArrayIterable(this.proposalIOList)) {
      this.proposalIOList.forEach(proposalIO => {
        if (proposalIO && proposalIO['proposalDO']) {
          let proposalDO = this.commonUtilty.deepCopy(proposalIO['proposalDO'])
          let ownerClients = this.commonUtilty.extractClientDOFromProposalIO(proposalIO, this.displayRoleCd)
          let ownerClient = null
          if (this.commonUtilty.isArrayIterable(ownerClients)) {
            ownerClient = ownerClients.find(cl => true)
          }
          let proposalIODataPoint: any = {}
          proposalIODataPoint.proposalNum = proposalDO['proposalNum'];
          proposalIODataPoint.statusCd = proposalDO['statusCd'];
          proposalIODataPoint.baseProductCd = proposalDO['baseProductCd'];
          if (ownerClient)
            proposalIODataPoint.ownerFullName = this.commonUtilty.getFirstNameFromClient(ownerClient) + " " + this.commonUtilty.getLastNameFromClient(ownerClient);
          else
            proposalIODataPoint.ownerFullName = "OWNER NOT FOUND"

          this.proposalIODataPointsList[proposalDO.proposalNum] = this.commonUtilty.deepCopy(proposalIODataPoint)
        }
      })

    }
  }

  subscribeToGetSelectedPolicies() {
    this.interactService.selectedPolicySubject$.subscribe(resp => {
      if (resp && resp.length > 0) {
        let response = Object.assign([], resp)
        if (this.policyList && this.policyList.length)
          this.policyList = this.policyList.concat(response);
        else {
          this.policyList = [];
          this.policyList = this.policyList.concat(response);
        }
        this.policyList = this.arrayManipulations.getUniqueElements(this.policyList, "proposalNum")
      }


    })
  }

  openPolicySearch() {
    this.openModal.emit("Open")
  }


  logData(data) {
    console.log(data)
  }


  parentEvent$
  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.EmitComponentOutput(this.getSelected())
    })
  }

  getParentComponentName(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  extractProposalDOsMAPOutOfListOfProposalIOs(proposalIOListResp) {
    let proposalDOsMap = {}
    if (this.commonUtilty.isArrayIterable(proposalIOListResp)) {
      proposalIOListResp.forEach(proposalIO => {
        if (proposalIO && proposalIO['proposalDO']) {
          if (proposalIO['proposalDO']['proposalNum'])
            proposalDOsMap[proposalIO['proposalDO']['proposalNum']] = this.commonUtilty.deepCopy(proposalIO['proposalDO']);
          else {
            console.error("A policy cannot be saved without a Policy Number", proposalIO);
          }
        }
        else {
          console.error("ProposalDO Missing in ProposalIO [extractListOfProposalDOsOutOfListOfProposalIOs in CapturedPolicyListComponent]", proposalIO)
        }
      });
    }
    return proposalDOsMap
  }

  getListOfProposalDOs(policyList, proposalDOsMap) {
    let proposalDOList = []
    if (this.commonUtilty.isArrayIterable(policyList)) {
      policyList.forEach(policySearchResultItem => {
        let proposalNum = policySearchResultItem['proposalNum']
        if (proposalDOsMap && proposalDOsMap[proposalNum] && Array.isArray(proposalDOList)) {
          let proposalDO = this.commonUtilty.deepCopy(proposalDOsMap[proposalNum])
          proposalDOList.push(proposalDO)
        }
      })
    }
    return proposalDOList
  }

  getListOfClaimProposalDOs(policyList, proposalDOsMap) {
    let claimProposalDOList = []
    if (this.commonUtilty.isArrayIterable(policyList)) {
      policyList.forEach(policySearchResultItem => {
        let proposalNum = policySearchResultItem['proposalNum']
        if (proposalDOsMap && proposalDOsMap[proposalNum] && Array.isArray(claimProposalDOList)) {
          let proposalDO = this.commonUtilty.deepCopy(proposalDOsMap[proposalNum])
          let claimProposalDO = this.mapProposalDOToClaimProposalDO(proposalDO);
          claimProposalDOList.push(this.commonUtilty.deepCopy(claimProposalDO))
        }
      })
    }
    return claimProposalDOList
  }

  propertyMapperClaimPolicyToProposalDO = {
    commencementDt: { transform: "UTCToLocalDate", sourceProperty: "policyCommencementDt" },
    expiryDt: { transform: "UTCToLocalDate", sourceProperty: "policyExpiryDt" },
    provider: null,
    proposalNum: null,
    baseProductFamilyCd: null,
    baseProductCd: null,
    baseProductTypeCd: null,
    sumInsured: null,
    policyIssueDt: { transform: "UTCToLocalDate", sourceProperty: "policyIssueDt" },
    statusCd: null,
    premiumPaid: null,
    remarks: null,
    baseAgentId: null,
    policyAge: null,
    premPaidTillDt: { transform: "UTCToLocalDate", sourceProperty: "premPaidTillDt" },
    reinstatementDt: { transform: "UTCToLocalDate", sourceProperty: "reinstatementDt" },
    earlyClaimFl: null,
    policyAgeInMonths: null,
    riskCategoryCd: null,
    policyTypeCd: null,
  }

  mapProposalDOToClaimProposalDO(proposalDO: any) {
    let claimProposalDO = new ClaimPolicyDO();
    for (const targetProperty in claimProposalDO) {
      if (this.propertyMapperClaimPolicyToProposalDO[targetProperty]) {
        if (this.propertyMapperClaimPolicyToProposalDO[targetProperty]['transform'] === 'UTCToLocalDate') {
          let convertedDate = this.commonUtilty.UIDOtoServerDODate(proposalDO[this.propertyMapperClaimPolicyToProposalDO[targetProperty]['sourceProperty']]);
          let convertedLocalDateTime = null
          if (convertedDate)
            convertedLocalDateTime = [...convertedDate, 0, 0]
          proposalDO[this.propertyMapperClaimPolicyToProposalDO[targetProperty]['sourceProperty']] = this.commonUtilty.deepCopy(convertedLocalDateTime)
        }
        claimProposalDO[targetProperty] = proposalDO[this.propertyMapperClaimPolicyToProposalDO[targetProperty]['sourceProperty']];
      }
      else {
        claimProposalDO[targetProperty] = proposalDO[targetProperty];
      }
    }
    return claimProposalDO
  }

  getSelected() {
    // return this.policyList.filter(data => data.selected)
    if (!this.appMetadataHandler.featureFlags.sendProposalDOsInTransaction &&
      !this.appMetadataHandler.featureFlags.sendClaimProposalDOInTransaction) {
      if (typeof this.policyList == typeof [] && this.policyList.length > 0)
        return this.policyList.filter(data => true)
    }
    else if (!!this.appMetadataHandler.featureFlags.sendClaimProposalDOInTransaction) {
      return this.getListOfClaimProposalDOs(this.policyList, this.proposalDOMap)
    }
    else if (!!this.appMetadataHandler.featureFlags.sendProposalDOsInTransaction) {
      return this.getListOfProposalDOs(this.policyList, this.proposalDOMap)
    }
    else
      return []
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }

  removePolicy(data, list, uniqueID) {
    this.policyList = this.commonUtilty.removeItemFromListUnSorted(data, list, uniqueID);
  }
}


